<template>
  <v-card dense>
    <v-card-title class="text-h7" style="font-weight: bold">
      <v-row>
        <v-col> {{ title == 0 ? "EDITAR" : "NUEVA" }} CUENTA BANCARIA </v-col>
        <div style="text-align: end" v-if="editedIndex != -1">
          <v-btn class="mx-2" fab dark small @click="cancelItemDetail(0)" color="error">
            <v-icon dark> mdi-close </v-icon>
          </v-btn>
        </div>
        <div style="text-align: end">
          <v-btn class="mx-2" fab dark small @click="addItemDetail()" color="success">
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </div>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row>
        <!-- Contenedor para SCTR Pensión -->
        <v-col class="s-col-form" sm="12" md="12" lg="12">
          <v-row>
            <v-col class="s-col-form" sm="4" md="4" lg="4">
              <s-select-definition
                :def="1487"
                label="Tipo de Cuenta"
                v-model="item.TypePay"
                ref="TypePayRef"
                :add="$fun.isAdmin()"
              />
            </v-col>
            <v-col class="s-col-form" sm="4" md="4" lg="4">
              <s-select-definition
                :def="1129"
                label="Moneda"
                v-model="item.TypeMoney"
                ref="TypeMoneyRef"
                :add="$fun.isAdmin()"
              />
            </v-col>
            <v-col class="s-col-form" sm="4" md="4" lg="4">
              <s-select-definition
                :def="1316"
                label="Entidad"
                v-model="item.TypeEntityBank"
                ref="TypeEntityBankRef"
                :add="$fun.isAdmin()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="s-col-form" sm="4" md="4" lg="4">
              <s-text
                label="N° Cuenta "
                v-model="item.BatAccountNumber"
                number
                :maxlength="maxlength"
                :showCounter="true"
                @keyupEnter="addItemDetail()"
                :rules="[
                  //value => !!value || 'aaa',
                  (value) =>
                    (value && value.length >= maxlength) ||
                    'El N° de Cuenta debe de tener  ' + maxlength + ' digitos',
                ]"
                ref="BatAccountNumberRef"
              >
              </s-text>
            </v-col>
            <v-col class="s-col-form" sm="4" md="4" lg="4">
              <s-text
                label="N° de Cuenta Interbancaria (CCI)"
                v-model="item.BatCCI"
                number
                :maxlength="20"
                :counter="20"
                @keyupEnter="addItemDetail()"
                :showCounter="true"
                :rules="[
                  //value => !!value || '',
                  (value) =>
                    (value && value.length >= 20) || 'EL CCI debe de tener 20 digitos',
                ]"
                ref="BatCCIRef"
              >
              </s-text>
            </v-col>
            <v-col class="s-col-form" sm="4" md="4" lg="4">
              <s-select-definition
                :def="1508"
                label="Situación de Cuenta"
                v-model="item.BatStatus"
                ref="BatStatusRef"
                :add="$fun.isAdmin()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="s-col-form" sm="3" md="3" lg="12">
              <s-switch
                label="Generar N° de Cuenta Correlativo"
                v-model="NumCorrelative"
              ></s-switch>
            </v-col>
            <v-col class="s-col-form" cols="12" sm="6"> </v-col>
            <v-col class="s-col-form" sm="6" md="6" lg="6"> </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="12" lg="12">
              <template>
                <v-data-table
                  :headers="bankAccountHeaders"
                  class="elevation-1"
                  :items="bankAccountDetail"
                  :sort-by="['SecStatus', 'TypePay', 'BatID']"
                  :sort-desc="[true]"
                >
                  <template v-slot:[`item.BatIsDefault`]="{ item }">
                    {{ item.BatIsDefault == 1 ? "Cuenta Principal" : "Cuenta Opcional" }}
                  </template>

                  <template v-slot:[`item.selected`]="{ item }">
                    <v-chip
                      small
                      style="cursor: pointer"
                      @click="selectBank(item)"
                      :color="item.selected ? 'success' : 'grey lighten-2'"
                      :text-color="item.selected ? 'white' : 'black'"
                    >
                      <v-icon small left v-if="item.selected">mdi-check-circle</v-icon>
                      {{ item.selected ? 'ANEXADO' : 'ANEXAR' }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.SecStatus`]="{ item }">
                    <v-chip
                      small
                      :color="item.SecStatus ? 'success' : ''"
                      :text-color="item.SecStatus ? 'white' : ''"
                    >
                      {{ item.SecStatus ? "Activo" : "Inactivo" }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item, 0)">
                      mdi-pencil
                    </v-icon>
                    <v-icon small @click="deleteItem(item, 0)"> mdi-delete </v-icon>
                  </template>
                </v-data-table>
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import SText from "../SText.vue";
import _sWorkertService from "@/services/HumanResource/WorkerService.js";

export default {
  name: "sDataBanckingEdit",
  components: { SText },
  props: {
    visibleTitle: {
      type: Boolean,
      default: true,
    },
    full: {
      type: Boolean,
      default: false,
    },
    typeperson: {
      type: Number,
      default: 1,
    },
    addTypeSex: {
      type: Boolean,
      default: false,
    },
    addBirthDate: {
      type: Boolean,
      default: false,
    },
    addDriver: {
      type: Boolean,
      default: false,
    },
    datawork: { type: Object },
  },
  data() {
    return {
      dataWor: {},
      editing: false,
      item: {
        TypePay: 1,
        TypeAccount: 3,
        TypeMoney: 1,
        TypeEntityBank: 2,
        BatAccountNumber: "",
        BatCCI: "",
        BatIsDefault: 1,
        BatStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
      },
      editedIndex: -1,
      itemDefault: {
        TypePay: 1,
        TypeAccount: 3,
        TypeMoney: 1,
        TypeEntityBank: 2,
        BatAccountNumber: "",
        BatCCI: "",
        BatIsDefault: 1,
        BatStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
      },
      title: 1,
      selectedCenterCost: 0,
      NumCorrelative: null,
      selectedBusinessLine: null,
      bankAccountHeaders: [
        { text: "ID", value: "BatID", sortable: false, width: 20 },
        { text: "Tipo de Cuenta", value: "TypePayName", sortable: false, width: 50 },
        { text: "Moneda", value: "TypeMoneyName", sortable: false, width: 20 },
        {
          text: "Entidad Bancaria",
          value: "TypeEntityBankName",
          sortable: false,
          width: 30,
        },
        { text: "N° de Cuenta", value: "BatAccountNumber", sortable: false, width: 100 },
        {
          text: "N° de Cuenta Interbancaria",
          value: "BatCCI",
          sortable: false,
          width: 100,
        },
        { text: "Categoria", value: "BatIsDefault", sortable: false, width: 80 },
        {
          text: "Situación de la Cuenta",
          value: "BatStatusName",
          sortable: false,
          width: 80,
        },
        { text: "Estado", value: "SecStatus", sortable: false, width: 30 },
        { text: "Acciones", value: "actions", sortable: false, width: 30 },
      ],
      bankAccountDetail: [],
      bankAccountDetailDelete: [],
      menu3: false,
      config: {},
      dialog: false,
      maxlength: 14,
    };
  },
  methods: {
    getDefinitionDescription(refName, value, fallback = "") {
      const items = this.$refs?.[refName]?.items || [];
      const found = items.find((x) => x.DedValue === value);
      return found?.DedDescription || fallback;
    },
    getAccountLengthByEntity() {
      const items = this.$refs?.TypeEntityBankRef?.items || [];
      const found = items.find((x) => x.DedValue === this.item.TypeEntityBank);
      const length = parseInt(found?.DedHelper || this.maxlength, 10);
      return Number.isNaN(length) ? this.maxlength : length;
    },
    initialize() {
      this.bankAccountDetail = [];
      const accounts =
        this.datawork?.BankAccountsCE ||
        this.datawork?.HmnBankAccount ||
        this.datawork?.BankAccount ||
        [];
      accounts.forEach((element) => {
        element.UsrUpdateID = this.$fun.getUserID();
        this.bankAccountDetail.push({ ...element });
      });
    },
    deleteItem(item) {
      item.SecStatus = item.SecStatus === 1 ? 0 : 1;
      item.BatIsDefault = item.SecStatus === 1 ? 1 : 2;
      item.UsrUpdateID = this.$fun.getUserID();
      this.editedIndex = -1;
    },

    selectBank(item) {
      if (!item) return;
      item.SecStatus = 1;
      item.BatIsDefault = 1;
      this.bankAccountDetail.forEach((x) => {
        x.selected = x === item;
        if (x !== item) x.BatIsDefault = 2;
      });
      this.$emit("update:selectedBatID", item.BatID || 0);
    },

    editItem(item) {
      this.isInitializing = true;
      this.editedIndex = this.bankAccountDetail.indexOf(item);

      this.item = {
        ...item,
      };
      this.item.BatAccountNumber = item.BatAccountNumber;
      this.title = 0;
    },

    cancelItemDetail() {
      this.editedIndex = -1;
      this.title = -1;
      this.item = {
        ...this.itemDefault,
      };
      this.clearDetail();
    },

    addItemDetail() {
      if (!this.validateData()) return;

      let bankAccount = {
        BatID: this.item.BatID || 0,
        WkrID: this.datawork?.WkrID || 0,
        TypePay: this.item.TypePay || 1,
        TypePayName: this.getDefinitionDescription("TypePayRef", this.item.TypePay || 1),
        TypeMoney: this.item.TypeMoney,
        TypeMoneyName: this.getDefinitionDescription("TypeMoneyRef", this.item.TypeMoney),
        TypeEntityBank: this.item.TypeEntityBank,
        TypeEntityBankName: this.getDefinitionDescription(
          "TypeEntityBankRef",
          this.item.TypeEntityBank
        ),
        BatAccountNumber: (this.item.BatAccountNumber || "").replace(/\s+/g, ""),
        BatCCI: (this.item.BatCCI || "").replace(/\s+/g, ""),
        BatIsDefault: 1, // Enforce single active primary account
        BatStatus: this.item.BatStatus || 1,
        BatStatusName: this.getDefinitionDescription("BatStatusRef", this.item.BatStatus || 1),
        SecStatus: 1,
        UsrCreateID: this.item.BatID ? this.item.UsrCreateID : this.$fun.getUserID(),
        UsrUpdateID: this.item.BatID ? this.$fun.getUserID() : 0,
      };

      // Inactivate any existing active bank account so there is ONLY ONE active account
      this.bankAccountDetail.forEach((element, idx) => {
        if (element.SecStatus == 1 && idx !== this.editedIndex) {
          element.SecStatus = 0;
          element.BatIsDefault = 2;
        }
      });

      if (this.editedIndex > -1) {
        Object.assign(this.bankAccountDetail[this.editedIndex], bankAccount);
        this.editedIndex = -1;
      } else {
        this.bankAccountDetail.push(bankAccount);
      }

      this.title = -1;
      this.clearDetail();
    },

    clearDetail() {
      this.item = { ...this.itemDefault };
      this.NumCorrelative = null;

      if (this.$refs.BatAccountNumberRef) this.$refs.BatAccountNumberRef.touched = false;
      if (this.$refs.BatCCIRef) {
        this.$refs.BatCCIRef.touched = false;
        this.$refs.BatCCIRef.hasError = false;
        this.$refs.BatCCIRef.errorMessage = "";
      }
    },

    close() {
      this.$refs.document.focus();
      this.$emit("toclose", 2);
      this.clear();
    },
    save() {},
    getData() {
      if (this.validateDetail()) {
        return [...this.bankAccountDetailDelete, ...this.bankAccountDetail];
      } else {
        return false;
      }
    },

    validateDetail() {
      const hasActive = this.bankAccountDetail.some((element) => element.SecStatus == 1);
      if (!hasActive) {
        this.$fun.alert("Es obligatorio contar con una Cuenta Bancaria activa", "warning");
        return false;
      }
      return true;
    },

    validateData() {
      let valid = true;
      //console.log("Data Bancarios", this.item);

      this.item.BatAccountNumber = this.item.BatAccountNumber.replace(/\s+/g, "");

      // if(this.bankAccountDetail.some(element => element.BatIsDefault === 1 && this.bankAccountDetail.indexOf(element) != this.editedIndex  && element.TypePay === this.item.TypePay )) {
      //   this.$fun.alert("Solo puede haber una Cuenta Bancaria Principal del tipo de Pago ->"+this.$refs.TypePayRef.items.find(
      //   (x) => x.DedValue === this.item.TypePay
      // ).DedDescription , "warning");
      //   valid = false;
      // }

      if (
        this.item.BatAccountNumber.length === 0 ||
        this.item.BatAccountNumber.length < this.maxlength
      ) {
        //this.maxlength =  this.item.TypeAccount == 4 ? 20 :  this.maxlength;
        let message = "El N° de Cuenta debe de tener  " + this.maxlength + " dígitos";
        this.$fun.alert(message, "warning");
        valid = false;
      }

      if (this.item.BatCCI.length > 0 && this.item.BatCCI.length < 20) {
        this.$fun.alert("El CCI debe de tener  20 dígitos", "warning");
        valid = false;
      }

      return valid;
    },
  },
  watch: {
    "item.TypeEntityBank"() {
      // console.log("entidad111111", this.$refs.TypeEntityBankRef.items.find(
      //     (x) => x.DedValue === this.item.TypeEntityBank
      //   ));
      this.maxlength = this.getAccountLengthByEntity();
    },
    NumCorrelative() {
      //console.log("entidad1111");
      if (this.NumCorrelative) {
        _sWorkertService.BankAccountCorrelative(this.$fun.getUserID()).then((r) => {
          if (r.status == 200) {
            //console.log("NumCorrelative", r.data);
            this.item.BatAccountNumber = r.data;
          }
        });
      } else {
        this.item.BatAccountNumber = "";
      }
    },
    datawork: {
      handler(newVal) {
        if (newVal) {
          this.initialize();
        }
      },
      immediate: true,
    },
  },
  created() {
    if (!this.datawork) {
      console.warn("datawork aún no está definido. Esperando su asignación.");
    }
  },
  computed: {},
};
</script>
